import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { CveDetail, FindingDetailsPayload } from '../../findingDetails/findingDetails/types';

export class EasmFindingDetailsDataProvider extends BaseWebComponentDataProvider {
  public async getDetailsForFinding(findingId: string): Promise<FindingDetailsPayload> {
    try {
      return await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'EASMFindings',
        method: 'getFindingDetails',
        payload: {
          findingId: findingId,
        },
      });
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async getCVEFromStandardIdsForCompany(companyId: string, cveStandardIds: Array<string>): Promise<CveDetail[]> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'GlobalInventoryCve',
      method: 'getCvesDetails',
      payload: {
        cvesStandardIds: cveStandardIds,
        companyId: companyId,
      },
    });
  }
}
